module.exports = __webpack_public_path__ + "media/Video 99.3478fa56.mp4";